import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class AddDropdownBasicMenu extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <span style={{ position:"relative", right: 32}}>
                <ButtonToolbar className = "btnToolbarAddMultipleExc pull-right" style={{ position:"relative", top:0}}>
                  <DropdownButton
                    bsStyle="default"
                    title="Add New Exercise"
                    noCaret
                    pullRight
                    id="dropdown-no-caret"
                    className="btnToolbarAddMultipleExc"
                    >
                      <MenuItem href="/exercise/new"
                                onSelect={this.props.handleAddExercise}
                                eventKey="1"
                                className="menuItemToolbarAddMultipleExc">
                          One Exercise
                      </MenuItem>
                      <MenuItem href="/exercise/ExerciseNewMultiple"
                                onSelect={this.props.handleAddExercise}
                                eventKey="2"
                                className="menuItemToolbarAddMultipleExc">
                          Multiple Exercises
                      </MenuItem>
                  </DropdownButton>
                </ButtonToolbar>
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/AddDropdownBasicMenu.js